module.exports = __webpack_public_path__ + "img/telegram.df7a73bf.svg";